export { DisclaimerPage as default } from '@/components/enpages/Ir/Disclaimer'
